// src/features/auth/services/authApi.js
import { apiFetch } from '../../../lib/http';

export const authApi = {
  /** GET /api/v1/auth/me -> { uid } */
  // getMe({ auth }) {
  //   return apiFetch('/api/v1/auth/me', { method: 'GET', auth });
  // },

  /** POST /api/v1/auth/login with { email, displayName } — requires Bearer token */
  login({ email, displayName, auth = true }) {
    return apiFetch('/api/v1/auth/login', {
      method: 'POST',
      auth,
      body: { email, displayName },
    });
  },
};

export function login({ email, displayName, auth = true }) {
  return apiFetch('/api/v1/auth/login', {
    method: 'POST',
    auth,
    body: { email, displayName },
  });
}